import { render } from "./AskDoubt.vue?vue&type=template&id=630c850a&scoped=true"
import script from "./AskDoubt.vue?vue&type=script&lang=js"
export * from "./AskDoubt.vue?vue&type=script&lang=js"

import "./AskDoubt.vue?vue&type=style&index=0&id=630c850a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630c850a"]])

export default __exports__